import React, { useEffect, useState } from "react";
import {
  Tabs,
  Button,
  MenuProps,
  Table,
  Typography,
  Card,
  Pagination,
  Space,
  Divider,
  DropDownProps,
  DatePicker,
  Spin,
} from "antd";
import BarChartOutlined from "@ant-design/icons/BarChartOutlined";
import DeleteOutlined from "@ant-design/icons/DeleteOutlined";
import DownloadOutlined from "@ant-design/icons/DownloadOutlined";
import FileTextOutlined from "@ant-design/icons/FileTextOutlined";
import ToolOutlined from "@ant-design/icons/ToolOutlined";
import UploadOutlined from "@ant-design/icons/UploadOutlined";
import { useModal } from "../lib/modal/ModalContext";
import { useAPI } from "../lib/hook/APIProvider";
import { Input } from "antd";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import FileUploadButton from "../lib/common/FileUploadButton";


import Dropdown, { DropdownOption } from "../lib/common/DropDown";
import DataCompareModal from "./DataCompareModal";

import { EntityMap } from "../../types/entities";
import ModalBase from "../lib/common/ModalBase";
import KPIDownloadModal from "./KPIDownloadModal";
import { useAuth } from "../lib/hook/AuthProvider";
interface Table {
  label: string;
  database: string;
  table: string;
  key: string;
}const { TabPane } = Tabs;

const tables: Table[] = [
  {
    label: "데이터 선택",
    database: "none",
    table: "none",
    key: "none",
  },
  {
    label: "차량 부품(tcms.ImpVehiclePartItems)",
    database: "tcms",
    table: "ImpVehiclePartItems",
    key: "차량 부품",
  },
  {
    label: "차량 신고서(tcms.ImpVehicle)",
    database: "tcms",
    table: "ImpVehicle",
    key: "차량 신고서",
  },
  {
    label: "차량 세액공제(ivis.IndvReduction)",
    database: "ivis",
    table: "IndvReduction",
    key: "차량 세액공제",
  },
  {
    label: "신고서 상세(tcms.ImpVehicleInvA)",
    database: "tcms",
    table: "ImpVehicleInvA",
    key: "신고서 상세",
  },
];

interface DownloadQuery {
  conditionA: string;
  conditionAOp: string;
  conditionB: string;
  conditionBOp: string;
}

const CRUDFeature: React.FC = () => {
  const { logout } = useAuth();
  const [targetTable, setTargetTable] = useState<Table | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [mainTableData, setMainTableData] = useState<any>(null);
  const [totalCount, setTotalCount] = useState<number>(0);

  const [queryparams, setQueryparams] = useState<any>({
    page: "1",
    pageSize: "10",
  });

  const [dropDownOption, setDropDownOption] = useState<DropdownOption[]>([]);

  const [downloadQuery, setDownloadQuery] = useState<DownloadQuery>({
    conditionA: "",
    conditionAOp: "",
    conditionB: "",
    conditionBOp: "",
  });

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const tableName = params.get("dropdown");
    if (tableName) {
      const foundTable = tables.find((t) => t.table === tableName);
      if (foundTable) {
        setTargetTable(foundTable);
      }
    }
  }, []);
  
  useEffect(() => {
    (async () => {
      if (targetTable?.database === "none" || targetTable === null) return;

      const queryString = new URLSearchParams(queryparams).toString();

      const result = await client.get(
        `preview/${targetTable?.database}/${targetTable?.table}?${queryString}`
      );

      setMainTableData(result.data.data);
      setTotalCount(result.data.total || 0);

      const entityInfo: string[] = Object.keys(
        EntityMap[targetTable?.table as string] || {}
      );

      const dropDownOption: DropdownOption[] = entityInfo.map((item) => {
        return {
          key: item,
          label: item,
        };
      });
      setDropDownOption(dropDownOption);

      setWhereKey(dropDownOption[0].key);
      setUpdateTargetKey(dropDownOption[1].key);
    })();
  }, [targetTable, queryparams]);

  const [whereKey, setWhereKey] = useState<string | null>(null);
  const [updateTargetKey, setUpdateTargetKey] = useState<string | null>(null);
  const { client } = useAPI();
  const { showModal, hideModal } = useModal();

  const handlePageChange = (page: number, pageSize?: number) => {
    setQueryparams({
      ...queryparams,
      page: page.toString(),
      pageSize: pageSize ? pageSize.toString() : queryparams.pageSize,
    });
  };

  const DownloadCreateFormat = async () => {
    const wb = new ExcelJS.Workbook();
    const ws = wb.addWorksheet(targetTable?.label);

    ws.columns = dropDownOption.map((item) => ({
      header: item.label,
      key: item.key,
      width: Math.max(10, String(item.label).length + 2),
    }));

    const buf = await wb.xlsx.writeBuffer();
    saveAs(
      new Blob([buf]),
      `${targetTable?.label}-${whereKey}-${updateTargetKey}-${new Date()}.xlsx`
    );
  };

  const DownloadUpdateFormat = async () => {
    if (whereKey === null) {
      alert("찾기 기준 선택해주세요");
      return;
    }
    if (updateTargetKey === null) {
      alert("일괄 변경 대상 선택해주세요");
      return;
    }

    const wb = new ExcelJS.Workbook();
    const ws = wb.addWorksheet(targetTable?.label);

    ws.columns = [
      {
        header: whereKey,
        key: whereKey,
        width: Math.max(10, String(whereKey).length + 2),
      },
      {
        header: updateTargetKey,
        key: updateTargetKey,
        width: Math.max(10, String(updateTargetKey).length + 2),
      },
    ];

    const buf = await wb.xlsx.writeBuffer();
    saveAs(
      new Blob([buf]),
      `${targetTable?.label}-${whereKey}-${updateTargetKey}-${new Date()}.xlsx`
    );
  };

  const DownloadDeletFormat = async () => {
    if (whereKey === null) {
      alert("찾기 기준 선택해주세요");
      return;
    }

    const wb = new ExcelJS.Workbook();
    const ws = wb.addWorksheet(targetTable?.label);

    ws.columns = [
      {
        header: whereKey,
        key: whereKey,
        width: Math.max(10, String(whereKey).length + 2),
      },
    ];

    const buf = await wb.xlsx.writeBuffer();
    saveAs(
      new Blob([buf]),
      `${targetTable?.label}-${whereKey}-${updateTargetKey}-${new Date()}.xlsx`
    );
  };

  const OnTryModifiyData = async (file: File) => {
    if (!file) {
      alert("엑셀 파일을 업로드해주세요!");
      return;
    }

    const wb = new ExcelJS.Workbook();
    const reader = new FileReader();
    const rows: any[] = [];
    reader.onload = async (e) => {
      const buffer = e.target?.result as ArrayBuffer;
      // xlsb/xls 등 xlsx가 아닌 파일이면 시트를 못 읽고 조용히 죽으므로 안내
      try {
        await wb.xlsx.load(buffer);
      } catch {}
      const ws = wb.worksheets[0];
      if (!ws) {
        alert(
          "엑셀 파일을 읽지 못했습니다.\nxlsx 형식만 지원합니다. xlsb/xls 파일은 Excel에서 '다른 이름으로 저장' → 'Excel 통합 문서(*.xlsx)'로 저장 후 업로드해주세요."
        );
        return;
      }

      const headers: string[] = ws.getRow(1).values as string[];

      ws.eachRow((row, rowNumber) => {
        if (rowNumber === 1) return;
        const rowData: Record<string, any> = {};
        row.eachCell((cell, colNumber) => {
          const header = headers[colNumber];
          if (header) {
            // 생성 탭과 동일한 관례: "null"/"" 입력 시 값 삭제(NULL)
            if (cell.value === "" || cell.value === "null") {
              rowData[header] = null;
            } else {
              rowData[header] = cell.value?.toString();
            }
          }
        });
        rows.push(rowData);
      });

      if (
        !window.confirm(
          `찾는 값의 기준 열은: ${headers[1]} \n일괄변환 할 기준 열은: ${headers[2]} \n셀에 null 입력 시 해당 값이 삭제(NULL) 됩니다 \n\n진헹하시겠습니까?`
        )
      ) {
        window.alert("작업이 취소되었습니다.");
        return;
      }

      const result = await client.patch(
        `preview/${targetTable?.database}/${targetTable?.table}/?key=${headers[1]}`,
        rows,
        { timeout: 0 }
      );

      showModal(
        <DataCompareModal
          onApplyData={async () => {
            const result = await client.patch(
              `preview/${targetTable?.database}/${targetTable?.table}/?key=${headers[1]}&isPreview=false`,
              rows,
              { timeout: 0 }
            );
            console.log(result);
          }}
          before={result.data.before}
          after={result.data.results}
        />
      );
    };

    reader.readAsArrayBuffer(file);
  };

  const OnTryCreateData = async (file: File) => {
    console.log("OnTryCreateData");
    if (!file) {
      alert("엑셀 파일을 업로드해주세요!");
      return;
    }

    const wb = new ExcelJS.Workbook();
    const reader = new FileReader();
    const rows: any[] = [];
    reader.onload = async (e) => {
      const buffer = e.target?.result as ArrayBuffer;
      try {
        await wb.xlsx.load(buffer);
      } catch {}
      const ws = wb.worksheets[0];
      if (!ws) {
        alert(
          "엑셀 파일을 읽지 못했습니다.\nxlsx 형식만 지원합니다. xlsb/xls 파일은 Excel에서 '다른 이름으로 저장' → 'Excel 통합 문서(*.xlsx)'로 저장 후 업로드해주세요."
        );
        return;
      }

      const headers: string[] = ws.getRow(1).values as string[];

      ws.eachRow((row, rowNumber) => {
        if (rowNumber === 1) return;
        const rowData: Record<string, any> = {};
        row.eachCell((cell, colNumber) => {
          const header = headers[colNumber];
          if (header) {
            if (cell.value === "") {
              rowData[header] = null;
            } else if (cell.value === "null") {
              rowData[header] = null;
            } else {
              rowData[header] = cell.value?.toString();
            }
          }
        });
        rows.push(rowData);
      });

      const result = await client.post(
        `preview/${targetTable?.database}/${targetTable?.table}/`,
        rows
        ,
        { timeout: 0 }
      );
      console.log(result.data);

      showModal(
        <DataCompareModal
          onApplyData={async () => {
            const result = await client.post(
              `preview/${targetTable?.database}/${targetTable?.table}?isPreview=false`,
              rows,
              { timeout: 0 }
            );
            console.log(result);
          }}
          before={null}
          after={result.data.results}
        />
      );
    };

    reader.readAsArrayBuffer(file);
  };

  const OnTryDeleteData = async (file: File) => {
    if (!file) {
      alert("엑셀 파일을 업로드해주세요!");
      return;
    }

    const wb = new ExcelJS.Workbook();
    const reader = new FileReader();
    const rows: any[] = [];
    reader.onload = async (e) => {
      const buffer = e.target?.result as ArrayBuffer;
      await wb.xlsx.load(buffer);

      const ws = wb.worksheets[0];

      const headers: string[] = ws.getRow(1).values as string[];

      ws.eachRow((row, rowNumber) => {
        if (rowNumber === 1) return;
        const rowData: Record<string, any> = {};
        row.eachCell((cell, colNumber) => {
          const header = headers[colNumber];
          if (header) {
            rowData[header] = cell.value?.toString();
          }
        });
        rows.push(rowData);
      });

      if (
        !window.confirm(
          `찾는 값의 기준 열은: ${headers[1]} \n\n진헹하시겠습니까?`
        )
      ) {
        window.alert("작업이 취소되었습니다.");
        return;
      }

      const result = await client.delete(
        `preview/${targetTable?.database}/${targetTable?.table}?key=${headers[1]}`,
        { data: rows }
      );

      showModal(
        <DataCompareModal
          onApplyData={async () => {
            const result = await client.delete(
              `preview/${targetTable?.database}/${targetTable?.table}?key=${headers[1]}&isPreview=false`,
              { data: rows }
            );
            console.log(result);
          }}
          before={result.data.before}
          after={null}
        />
      );
    };

    reader.readAsArrayBuffer(file);
  };

  return (
    <div className=" flex flex-col h-screen w-full bg-gray-300 overflow-y-clip">
      {/* <div className="p-4 flex gap-2 justify-start items-center">
        <Dropdown
          options={tables.map((table) => ({
            key: table.key,
            label: table.label,
          }))}
          buttonClassName="px-4 w-[360px] h-[40px] flex justify-between items-center rounded-md border border-gray-300 bg-white shadow-sm hover:border-blue-400 focus:outline-none focus:ring-2 focus:ring-blue-200 transition-all duration-150"
          dropdownClassName="bg-white w-[360px] max-h-[320px] flex flex-col border border-gray-200 shadow-lg rounded-md overflow-y-auto mt-1"
          itemClassName="px-4 py-2 w-full text-left text-gray-700 hover:bg-blue-50 transition-colors duration-100 cursor-pointer"
          itemSelectedClassName="px-4 py-2 w-full text-left bg-blue-100 text-blue-700 font-semibold rounded"
          itemHoverClassName="bg-blue-50 px-4 py-2 w-full text-left"
          selectedOptionKey={targetTable?.key || "none"}
          onOptionChange={(key) => {
            const selectedTable =
              tables.find((table) => table.key === key) || null;
            console.log(selectedTable);
            setTargetTable(selectedTable);
          }}
        ></Dropdown>
        <div className="w-px h-10 bg-gray-400 mx-4" />
        <Button
          type="default"
          style={{ background: "white" }}
          onClick={() => {
            window.location.pathname = "/hs-code-update";
          }}
          icon={<ToolOutlined />}
        >
          차량 품목마스터 세번 변경
        </Button>
        <Button
          type="default"
          style={{ background: "white" }}
          onClick={() => {
            window.location.pathname = "/report-batch-remover";
          }}
          icon={<DeleteOutlined />}
        >
          일괄 신고서 삭제 작업
        </Button>

        <Button
          type="default"
          style={{ background: "white" }}
          onClick={() => showModal(<KPIDownloadModal></KPIDownloadModal>)}
          loading={isLoading}
          icon={<BarChartOutlined />}
        >
          KPI 데이터 취합 후 다운로드
        </Button>
        <Button type="default" style={{ background: "white" }} onClick={logout}>
          로그아웃
        </Button>
      </div> */}
      {targetTable?.table !== "none" && targetTable?.table !== undefined && (
        <div className="flex flex-1 w-full h-0 min-h-0 ">
          <div className="px-4  bg-gray-100 flex flex-col justify-start items-start min-w-[425px] h-full">
            <Tabs defaultActiveKey="2">
              <TabPane tab="생성" key="1">
                <Card title="1. 일괄 작업 서식 받기" style={{ width: "100%" }}>
                  <Button
                    type="default"
                    onClick={DownloadCreateFormat}
                    icon={<DownloadOutlined />}
                  >
                    변경 서식 받기
                  </Button>
                </Card>
                <div className="h-5"></div>

                <Card
                  title="2. 엑셀 업로드 후 일괄작업 수행"
                  style={{ width: "100%" }}
                >
                  <FileUploadButton onFileSelect={OnTryCreateData} accept=".xlsx">
                    <Button type="default" icon={<UploadOutlined />}>
                      일괄 작업 생성
                    </Button>
                  </FileUploadButton>
                </Card>
              </TabPane>
              <TabPane tab="수정" key="2">
                <Card title="1. 일괄 작업 서식 받기" style={{ width: "100%" }}>
                  <Typography.Text>찾기 대상 열 이름</Typography.Text>
                  <Dropdown
                    options={dropDownOption}
                    selectedOptionKey={whereKey ?? "????"}
                    onOptionChange={(key) => setWhereKey(key)}
                    buttonClassName="px-4 w-[360px] h-[40px] flex justify-between items-center rounded-md border border-gray-300 bg-white shadow-sm hover:border-blue-400 focus:outline-none focus:ring-2 focus:ring-blue-200 transition-all duration-150"
                    dropdownClassName="bg-white w-[360px] max-h-[320px] flex flex-col border border-gray-200 shadow-lg rounded-md overflow-y-auto mt-1"
                    itemClassName="px-4 py-2 w-full text-left text-gray-700 hover:bg-blue-50 transition-colors duration-100 cursor-pointer"
                    itemSelectedClassName="px-4 py-2 w-full text-left bg-blue-100 text-blue-700 font-semibold rounded"
                    itemHoverClassName="bg-blue-50 px-4 py-2 w-full text-left"
                  />
                  <div className="h-5"></div>
                  <Typography.Text>변경 열 이름</Typography.Text>
                  <Dropdown
                    options={dropDownOption}
                    selectedOptionKey={updateTargetKey ?? ""}
                    onOptionChange={(key) => setUpdateTargetKey(key)}
                    buttonClassName="px-4 w-[360px] h-[40px] flex justify-between items-center rounded-md border border-gray-300 bg-white shadow-sm hover:border-blue-400 focus:outline-none focus:ring-2 focus:ring-blue-200 transition-all duration-150"
                    dropdownClassName="bg-white w-[360px] max-h-[320px] flex flex-col border border-gray-200 shadow-lg rounded-md overflow-y-auto mt-1"
                    itemClassName="px-4 py-2 w-full text-left text-gray-700 hover:bg-blue-50 transition-colors duration-100 cursor-pointer"
                    itemSelectedClassName="px-4 py-2 w-full text-left bg-blue-100 text-blue-700 font-semibold rounded"
                    itemHoverClassName="bg-blue-50 px-4 py-2 w-full text-left"
                  />
                  <div className="h-5"></div>
                  <Button
                    type="default"
                    onClick={DownloadUpdateFormat}
                    icon={<DownloadOutlined />}
                  >
                    변경 서식 받기
                  </Button>
                </Card>
                <div className="h-5"></div>
                <Card
                  title="2. 엑셀 업로드 후 일괄작업 수행"
                  style={{ width: "100%" }}
                >
                  <FileUploadButton onFileSelect={OnTryModifiyData} accept=".xlsx">
                    <Button type="default" icon={<UploadOutlined />}>
                      일괄 변경
                    </Button>
                  </FileUploadButton>
                </Card>
              </TabPane>
              {/* <TabPane tab="삭제" key="3">
                <Card title="1. 일괄 작업 서식 받기" style={{ width: "100%" }}>
                  <Typography.Text>찾기 대상 열 이름</Typography.Text>
                  <Dropdown
                    options={dropDownOption}
                    selectedOptionKey={whereKey ?? "????"}
                    onOptionChange={(key) => setWhereKey(key)}
                    buttonClassName="px-4 w-[360px] h-[40px] flex justify-between items-center rounded-md border border-gray-300 bg-white shadow-sm hover:border-blue-400 focus:outline-none focus:ring-2 focus:ring-blue-200 transition-all duration-150"
                    dropdownClassName="bg-white w-[360px] max-h-[320px] flex flex-col border border-gray-200 shadow-lg rounded-md overflow-y-auto mt-1"
                    itemClassName="px-4 py-2 w-full text-left text-gray-700 hover:bg-blue-50 transition-colors duration-100 cursor-pointer"
                    itemSelectedClassName="px-4 py-2 w-full text-left bg-blue-100 text-blue-700 font-semibold rounded"
                    itemHoverClassName="bg-blue-50 px-4 py-2 w-full text-left"
                  />
                  <div className="h-5"> </div>
                  <Button
                    type="default"
                    onClick={DownloadDeletFormat}
                    icon={<DownloadOutlined />}
                  >
                    삭제 서식 받기
                  </Button>
                </Card>
                <div className="h-5"> </div>
                <Card
                  title="2. 엑셀 업로드 후 일괄작업 수행"
                  style={{ width: "100%" }}
                >
                  <FileUploadButton onFileSelect={OnTryDeleteData}>
                    <Button type="default" icon={<UploadOutlined />}>
                      일괄 변경
                    </Button>
                  </FileUploadButton>
                </Card>
              </TabPane> */}
              <TabPane tab="엑셀 저장" key="4">
                <Card title="저장 범위 결정">
                  <div>
                    <Typography.Text>대상 열</Typography.Text>
                    <Dropdown
                      options={[
                        { key: "none", label: "조건 없음" },
                        ...dropDownOption,
                      ]}
                      selectedOptionKey={whereKey || "none"}
                      onOptionChange={(key) => setWhereKey(key)}
                      buttonClassName="px-4 w-[360px] h-[40px] flex justify-between items-center rounded-md border border-gray-300 bg-white shadow-sm hover:border-blue-400 focus:outline-none focus:ring-2 focus:ring-blue-200 transition-all duration-150"
                      dropdownClassName="bg-white w-[360px] max-h-[320px] flex flex-col border border-gray-200 shadow-lg rounded-md overflow-y-auto mt-1"
                      itemClassName="px-4 py-2 w-full text-left text-gray-700 hover:bg-blue-50 transition-colors duration-100 cursor-pointer"
                      itemSelectedClassName="px-4 py-2 w-full text-left bg-blue-100 text-blue-700 font-semibold rounded"
                      itemHoverClassName="bg-blue-50 px-4 py-2 w-full text-left"
                    />
                  </div>
                  <div>
                    <Typography.Text>조건 A</Typography.Text>
                    <div className="flex gap-2">
                      <Input
                        placeholder="2022-02-22T02:02:00"
                        onChange={(e:any) =>
                          setDownloadQuery((prev: any) => ({
                            ...prev,
                            conditionA: e.target.value,
                          }))
                        }
                        value={downloadQuery.conditionA || ""}
                      />
                      <Dropdown
                        options={[
                          { key: "_max", label: "작거나 같음" },
                          { key: "_min", label: "크거나 같음" },
                          { key: "", label: "같음" },
                        ]}
                        selectedOptionKey={downloadQuery.conditionAOp || ""}
                        onOptionChange={(key) =>
                          setDownloadQuery((prev: any) => ({
                            ...prev,
                            conditionAOp: key,
                          }))
                        }
                        buttonClassName="px-4 w-[130px] h-[40px] flex justify-between items-center rounded-md border border-gray-300 bg-white shadow-sm hover:border-blue-400 focus:outline-none focus:ring-2 focus:ring-blue-200 transition-all duration-150"
                        dropdownClassName="bg-white w-[130px]] max-h-[320px] flex flex-col border border-gray-200 shadow-lg rounded-md overflow-y-auto mt-1"
                        itemClassName="px-4 py-2 w-full text-left text-gray-700 hover:bg-blue-50 transition-colors duration-100 cursor-pointer"
                        itemSelectedClassName="px-4 py-2 w-full text-left bg-blue-100 text-blue-700 font-semibold rounded"
                        itemHoverClassName="bg-blue-50 px-4 py-2 w-full text-left"
                      />
                    </div>
                  </div>
                  <div>
                    <Typography.Text>조건 B</Typography.Text>
                    <div className="flex gap-2">
                      <Input
                        placeholder="2022-02-22T02:02:00"
                        onChange={(e:any) =>
                          setDownloadQuery((prev: any) => ({
                            ...prev,
                            conditionB: e.target.value,
                          }))
                        }
                        value={downloadQuery.conditionB || ""}
                      />
                      <Dropdown
                        options={[
                          { key: "_max", label: "작거나 같음" },
                          { key: "_min", label: "크거나 같음" },
                          { key: "", label: "같음" },
                        ]}
                        selectedOptionKey={downloadQuery.conditionBOp || ""}
                        onOptionChange={(key) =>
                          setDownloadQuery((prev: any) => ({
                            ...prev,
                            conditionBOp: key,
                          }))
                        }
                        buttonClassName="px-4 w-[130px] h-[40px] flex justify-between items-center rounded-md border border-gray-300 bg-white shadow-sm hover:border-blue-400 focus:outline-none focus:ring-2 focus:ring-blue-200 transition-all duration-150"
                        dropdownClassName="bg-white w-[130px] max-h-[320px] flex flex-col border border-gray-200 shadow-lg rounded-md overflow-y-auto mt-1"
                        itemClassName="px-4 py-2 w-full text-left text-gray-700 hover:bg-blue-50 transition-colors duration-100 cursor-pointer"
                        itemSelectedClassName="px-4 py-2 w-full text-left bg-blue-100 text-blue-700 font-semibold rounded"
                        itemHoverClassName="bg-blue-50 px-4 py-2 w-full text-left"
                      />
                    </div>
                  </div>
                  <div className="h-5"> </div>

                  <Button
                    type="default"
                    onClick={async () => {
                      const query: any = {};

                      query["pageSize"] = "1000000";

                      if (
                        downloadQuery.conditionA === "" &&
                        downloadQuery.conditionB === ""
                      ) {
                        const proceed = window.confirm(
                          "조건이 없으면 전체 데이터를 다운로드 합니다. 전체 데이터를 다운로드 하시겠습니까?"
                        );
                        if (!proceed) {
                          return;
                        }
                      }
                      if (downloadQuery.conditionA !== "") {
                        const field = `${whereKey}${downloadQuery.conditionAOp}`;
                        console.log(field);
                        query[field] = downloadQuery.conditionA;
                      }
                      if (downloadQuery.conditionB !== "") {
                        const field = `${whereKey}${downloadQuery.conditionBOp}`;
                        console.log(field);
                        query[field] = downloadQuery.conditionB;
                      }
                      const queryString = new URLSearchParams(query).toString();
                      const result = await client.get(
                        `preview/${targetTable?.database}/${targetTable?.table}?${queryString}`,
                        { timeout: 0 }
                      );

                      if (
                        result &&
                        result.data &&
                        Array.isArray(result.data.data)
                      ) {
                        const data = result.data.data;
                        if (data.length > 0) {
                          const keys = Object.keys(data[0]);
                    
                          const csvRows = [keys.join(",")];
                    
                          data.forEach((row: any) => {
                            const rowData = keys
                              .map((key) => {
                                const cell = row[key];
                                if (cell === null || cell === undefined) return "";
                          
                                const cellStr = String(cell).replace(/"/g, '""');
                                if (
                                  cellStr.includes(",") ||
                                  cellStr.includes('"') ||
                                  cellStr.includes("\n")
                                ) {
                                  return `"${cellStr}"`;
                                }
                                return cellStr;
                              })
                              .join(",");
                            csvRows.push(rowData);
                          });
                          const csvContent = "\uFEFF" + csvRows.join("\r\n"); // BOM과 CRLF
                          saveAs(
                            new Blob([csvContent], { type: "text/csv;charset=utf-8;" }),
                            `${targetTable?.label || "data"}_download.csv`
                          );
                        } else {
                          window.alert("다운로드할 데이터가 없습니다.");
                        }
                    }}}
                    icon={<DownloadOutlined />}
                  >
                    데이터 다운로드
                  </Button>
                </Card>
              </TabPane>
            </Tabs>
          </div>

          <div className="bg-white pl-4 pt-[20px] flex flex-1 flex-col h-full gap-1 overflow-y-scroll overflow-x-hidden">
            {mainTableData && (
              <>
                <Typography.Title level={3}>데이터 미리보기 </Typography.Title>
                <Table
                  columns={
                    mainTableData && mainTableData.length > 0
                      ? Object.keys(mainTableData[0]).map((key) => ({
                          title: key,
                          dataIndex: key,
                          key,
                          render: (text: any) => (
                            <div
                              style={{
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                maxWidth: 200,
                              }}
                            >
                              {String(text)}
                            </div>
                          ),
                        }))
                      : []
                  }
                  scroll={{ x: true }}
                  dataSource={mainTableData}
                  pagination={false}
                />
                <Pagination
                  current={parseInt(queryparams.page)}
                  pageSize={parseInt(queryparams.pageSize)}
                  total={totalCount}
                  onChange={handlePageChange}
                  showSizeChanger
                  showQuickJumper
                  showTotal={(total :any, range:any) =>
                    `${range[0]}-${range[1]} of ${total} items`
                  }
                />
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
};
export default CRUDFeature;
